<template>
  <div style="height:auto; width:100%;">
    <!--TODO: meter commodites-->

    <!-- ============= form =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div
        class="col col-10"
        style="background: var(--darkbackground); min-height: 70px"
      >
        <form @submit.prevent="validateBeforeSubmit">
          <!-- https://logaretm.github.io/vee-validate/guide/basics.html#validation-provider -->
          <div class="row f-row">
            <div class="col col-1 text-center">COMPANY:</div>
            <div class="col col-2 text-center">
              <input
                v-validate="'required|max:30'"
                class="custom-input-2"
                name="company"
                placeholder="Company Name"
                v-model="companyName"
                :class="{ input: true, 'is-danger': errors.has('company') }"
                type="text"
              />
            </div>
            <div class="col col-1 text-center">PORTFOLIO:</div>
            <div class="col col-2 text-center">
              <input
                v-validate="'required|max:30'"
                class="custom-input-2"
                name="portolio"
                placeholder="Portfolio Name"
                v-model="portfolioName"
                :class="{ input: true, 'is-danger': errors.has('portolio') }"
                type="text"
              />
            </div>
            <div class="col col-1 text-center">CURRENCIES:</div>
            <div class="col col-2 text-center">
              <multiselect
                v-model="selectedCurrencies"
                :options="currencies"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allowEmpty="false"
                :taggable="true"
                label="currency_name"
                track-by="currency_name"
                placeholder="Search..."
                :preselect-first="true"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                >
                  <span
                    class="multiselect__single"
                    v-if="values.length == 1 &amp;&amp; !isOpen"
                  >
                    {{ values[0].currency_name }}
                  </span>
                  <span
                    class="multiselect__single"
                    v-else-if="values.length > 1 &amp;&amp; !isOpen"
                  >
                    {{ values.length }} SELECTED
                  </span>
                </template>
              </multiselect>
            </div>
            <div class="col col-cx align-content-center text-center">
              <button type="submit" class="btn btn-sm btn-home">
                <span v-if="showLoading" class="text-left">
                  <v-progress-circular
                    indeterminate
                    :size="18"
                    :width="2.5"
                    color="var(--textactive)"
                  ></v-progress-circular
                ></span>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- ============= Show Errors =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div class="col col-10 btn-warn text-center">
        <span v-show="errors.has('company')"
          >{{ errors.first("company") }}.<br
        /></span>
        <span v-show="errors.has('portolio')"
          >{{ errors.first("portolio") }}.<br
        /></span>
      </div>
    </div>

    <!-- Loading Modal -->
    <Messages :modal_message="modal_processing_message" />
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
import Messages from "../components/modals/Messages.vue";
import { Company } from "@/_core/data/Company";
import { apiService } from "@/_services";
import { mapState } from "vuex";

export default {
  name: "CreateCompanyPortfolio",
  components: {
    multiselect,
    Messages
  },
  data() {
    return {
      user: "",
      companyName: "",
      portfolioName: "",
      currencies: [],
      selectedCurrencies: [],
      commodities: [],
      showLoading: false,
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false
      },
      processed_company: null,
      showModalLoading: false
    };
  },
  computed: mapState(["status"]),
  created() {
    try {
      this.currencies = this.$store.state.currencies.all.items;
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }
    try {
      this.processed_company = new Company(this);
    } catch (error) {
      console.log(`Error companies loader ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }

    this.unwatch = this.$store.watch(
      (state, getters) => getters.status,
      (newValue, oldValue) => {
        console.log(`Updating from ${oldValue} to ${newValue}`);
      }
    );
  },
  methods: {
    validateBeforeSubmit() {
      this.showLoading = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          let currenciesList = this.selectedCurrencies.map(function(
            currencyObject
          ) {
            return currencyObject.currency_name;
          });
          /***
           * Company First Time Register
           */
          let params = {
            method: "POST",
            endpoint: "infouser",
            content_type: "application/json",
            query_params: {
              format: "json",
              company_name: this.companyName,
              portfolios: [
                {
                  fk_currency: currenciesList,
                  portfolio_name: this.portfolioName
                }
              ],
              fk_iduser: [
                {
                  pk_idusers: this.user.pk_idusers
                }
              ]
            }
          };
          this.modal_processing_message.showModalLoading = !this
            .modal_processing_message.showModalLoading;
          this.modal_processing_message.messageModal = "Processing....";
          var delay_state = this;
          apiService
            .getAll(params)
            .then(data => {
              this.processed_company.onLoadData();
              setTimeout(function() {
                delay_state.modal_processing_message.showModalLoading = !delay_state
                  .modal_processing_message.showModalLoading;
                delay_state.modal_process_finished_message.showModalLoading = !delay_state
                  .modal_process_finished_message.showModalLoading;
                delay_state.modal_process_finished_message.optionsModal = true;
                delay_state.modal_process_finished_message.messageModal = data;
                delay_state.showLoading = false;
                delay_state.onAfterSaveCompany();
              }, 10000);
              this.saveLegendExpo = "Saved:";
              this.refreshLegendExpo = "Synced:";
            })
            .catch(function(error) {
              console.log("An error has ocurred" + error);
            });
        } else {
          this.showLoading = false;
          this.onAfterSaveCompany();
        }
      });
    },
    onAfterSaveCompany() {
      this.$emit("eventOnAfterSaveCompany");
    },
    onBeforeSaveCompany() {
      this.$emit("eventOnBeforeSaveCompany");
    }
  }
};
</script>

<style scoped></style>
